import React from "react";
import AssetImportSourceAndToken from "../../../AssetImportSourceAndToken";
import CreateOktaImportFlow from "./CreateOktaImportFlow";
import SectionMessage from "@atlaskit/section-message";
import SaveAssetToken from "../../../../common/auth/SaveAssetToken";
import { useSelector } from "react-redux";
import SaveCustomHeaderAuth
 from "../../../../common/auth/SaveCustomHeaderAuth";
const ConfirmOktaImport = () => {
  const currentData = useSelector((state) => state.wizard.currentData);

  const AUTH_VALUE = "SSWS "+currentData.oktaToken
  const credValue = currentData.selectedOktaAuthOption === "WizardHeaderAuth" ? [{key:"Authorization",value:AUTH_VALUE}] : currentData.oktaCredential.value

  return (
    <> 
    <br></br>
     <SectionMessage title="Information" appearance="success">
        <p>
        Great news! Your scheduled Okta import into Jira Assets is complete and ready to go. Just click the link below to access it.
        </p>
        <AssetImportSourceAndToken />
        <SaveAssetToken assetTokenName="Okta Import: Asset Import Token"/>
        <br></br>
        <SaveCustomHeaderAuth credName="Okta Read Token" credRefProperty="oktaCredRef" authRadioButtonProperty="selectedOktaAuthOption" createNewAuthRadioBtnValue="WizardHeaderAuth" value={credValue} />
        <CreateOktaImportFlow/>
      </SectionMessage>
    
   </>
  );
};
export default ConfirmOktaImport;
